var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartazul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03267 11.4978L7.10767 6.42279L10.491 9.80612L17.6806 1.70304L16.488 0.501953L10.491 7.26862L7.10767 3.88529L0.763916 10.229L2.03267 11.4978Z",
    fill: "#0F0742"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartazul);
export default __webpack_public_path__ + "static/media/chartazul.a29634c94c00ac6dd971efb989b90ebf.svg";
export { ForwardRef as ReactComponent };